import { render, staticRenderFns } from "./appright.vue?vue&type=template&id=3404d7b6&scoped=true&"
import script from "./appright.vue?vue&type=script&lang=js&"
export * from "./appright.vue?vue&type=script&lang=js&"
import style0 from "./appright.vue?vue&type=style&index=0&id=3404d7b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3404d7b6",
  null
  
)

export default component.exports